import React, { Component } from "react";
import { AiOutlineHome } from "react-icons/ai";

import stl from "./ReferenceHeader.module.scss";

class ReferenceHeader extends Component {
	render() {
		return (
			<>
				{/*<div id={stl.headerWrapper}></div>*/}
				{/*<div id={stl.breadcrumbs}>*/}
					{/*<div className={stl.wrapper}>*/}
						{/*<div id={stl.nav}>*/}
							{/*<img src='/sis/images/main/board/navHome.png' id={stl.navHome}/>*/}
							{/*&nbsp;&nbsp;<img src='/sis/images/main/board/navNext.png' id={stl.navNext}/>&nbsp;&nbsp; <span id={stl.navText}>통계연보</span>*/}
						{/*</div>*/}
					{/*</div>*/}
				{/*</div>*/}
				<div id={stl.iconWrapper}>
					<div className={stl.iconContainer}>
						<span className={stl.title}>통계연보</span>
						{/*<span className={stl.contents}>전남광주통합특별시 스마트도시분석포털 자료실입니다.</span>*/}
					</div>
				</div>
			</>
		);
	}
}

export default ReferenceHeader;
